export default function BulletPoint() {
    return (
        <div>
            <svg width="15" height="15" viewBox="0 0 15 15">
                <g id="Ellipse_44" data-name="Ellipse 44" fill="#8ce68c" stroke="#72bf72" stroke-width="2">
                    <circle cx="7.5" cy="7.5" r="7.5" stroke="none"/>
                    <circle cx="7.5" cy="7.5" r="6.5" fill="none"/>
                </g>
            </svg>
        </div>
    )
}